import { acceptHMRUpdate, defineStore } from "pinia";

import { useLoadedModel } from "./loadedModel.store";
import type { EditorAreaName } from "./editorAreas";

export interface ProjectState {
  exportedModelName: string | null;
  title: string;
  description: string;

  createdAt: number;
  docs: { [key: string]: string };

  readOnly: boolean;
  author: string | null;
}

export const useProjectStore = defineStore("model/project", {
  state: (): ProjectState => ({
    title: "",
    description: "",

    createdAt: Date.now(),

    docs: {},

    // business game info
    readOnly: false,
    author: null,
    exportedModelName: null
  }),
  getters: {
    isReadOnly(state): boolean {
      return state.readOnly === true;
    },
    canAreaBeDisplayed(): (areaName: EditorAreaName) => boolean {
      return canAreaBeDisplayed;
    }
  },
  actions: {
    set(options: { [key: string]: unknown }) {
      this.$patch((state) => {
        Object.assign(state, options);
      });
    }
  }
});

export function canAreaBeDisplayed(areaName: EditorAreaName): boolean {
  const loadedModel = useLoadedModel().loadedModel;
  if (loadedModel.accessableAreas) {
    if (!loadedModel.accessableAreas.includes(areaName)) return false;
  }
  if (areaName === "model" || areaName === "variables") {
    return !useProjectStore().isReadOnly;
  }
  return true;
}

if (import.meta.hot) {
  import.meta.hot.accept(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    acceptHMRUpdate(useProjectStore as any, import.meta.hot)
  );
}
